import { UserFilterParameters } from '../user-filter-parameters';

export const InitialUserFilter = new UserFilterParameters();
